import { render, staticRenderFns } from "./ProductSizeQuantityInputs.vue?vue&type=template&id=612bcb22"
import script from "./ProductSizeQuantityInputs.vue?vue&type=script&lang=js"
export * from "./ProductSizeQuantityInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports